

















import { Component, Mixins, Watch } from "vue-property-decorator";
import { ITreeCollapsable, ITreeExpandable, ManagementTokenCollaborativeMixin } from "../../../system";
import { FormatSetTreeSourceSelectableMixin } from "./mixins";
import FormatSetReferencesTreeSelector from "./FormatSetReferencesTreeSelector.vue";
import { FormatSetTreeEditDialog } from "./dialogs";
import { IEditFormatTree } from "./IEditFormatTree";
import { ManagementTokenPublishResult } from "../../../../domain/system";
import { DomainRegistry } from "../../../../domain";

@Component({
  components: {
    selector: FormatSetReferencesTreeSelector,
    editDialog: FormatSetTreeEditDialog,
  }
})
export default class FormatSetReferencesSelector extends Mixins(FormatSetTreeSourceSelectableMixin, ManagementTokenCollaborativeMixin) implements ITreeExpandable, ITreeCollapsable, IEditFormatTree {
  $refs!: {
    selector: FormatSetReferencesTreeSelector,
    editDialog: FormatSetTreeEditDialog,
  };
  
  @Watch("isLoaded")
  onIsLoadedUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      this.$nextTick(() => {
        if (this.$configuration.behavior.format.selector.shouldExpandTreeAutomatically) {
          this.expandTree();
        }
      });
    }
  }

  @Watch("filter")
  onFilterUpdated(): void {
    this.$nextTick(() => {
      if (this.isLoaded && this.$configuration.behavior.format.selector.shouldExpandTreeAutomatically) {
        this.expandTree();
      }
    });
  }

  expandTree(): void {
    this.expandSelectorTree(this.$refs.selector);
  }

  collapseTree(): void {
    this.collapseSelectorTree(this.$refs.selector);
  }

  async editFormatTree(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    if (this.treeSource.managementKey) {
      await this.executeWithManagementTokenControll(this.treeSource.entityName, isForcibly => this.getManagementToken(isForcibly), this.executeEditFormatSet);
    } else {
      // 個人の文書セットはチェック無しで編集開始する想定
      await this.executeEditFormatSet();
    }
  }

  private async getManagementToken(isForcibly: boolean): Promise<ManagementTokenPublishResult> {
    if (!this.treeSource.managementKey) { throw new Error("managementKey is empty!!!"); }
    const repo = DomainRegistry.format.getFormatRepository();
    return repo.getFormatSetManagementToken(this.treeSource.managementKey, isForcibly);
  }

  private async executeEditFormatSet(): Promise<void> {
    const isUpdated = await this.$refs.editDialog.show(this.shouldIgnoreChained);
    if (isUpdated) {
      await this.loadTree();
    }
  }
}
